<template>
    <div v-if="section.is_active">
        <h2 class="text-28 lg:text-36 text-navy font-bold mt-10 mb-2" id="new_hire_guarantee">TruckersReport New Hire Guarantee</h2>
        <div class="flex gap-x-8">
            <div class="bg-white shadow p-6 lg:p-8 tr-box lg:w-2/5 lg:my-20 lg:ml-16">
                <ul class="tr-bullets ml-4 flex flex-col gap-y-2 lg:gap-y-4">
                <li v-for="(bullet, index) in bullets" :key="index" v-html="bullet"></li>
                </ul>
            </div>
            <div class="hidden lg:flex w-2/5 relative">
                <img src="/proposal-presentation-files/img/guarantee.png" alt="Guarantee" class="absolute -top-1 z-10 right-4 max-w-full" style="max-height: 400px">
            </div>
        </div>
    </div>
</template>

<script>
import sellingPointMixin from '../sellingPointMixin';

export default {
    mixins: [
        sellingPointMixin
    ],
    props: [
        'section',
    ],
    computed: {
        bullets() {
            return this.formatBullets(this.section.content);
        },
    },
}
</script>